export default "__VITE_ASSET__dTj_MGV4__"